import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { appointmentAsMemberQueryKeys } from "./appointmentAsMemberQueryKeys";

export const useInfiniteQueryAppointmentPastAsMember = ({
  api,
  filters,
  enabled,
}: {
  api: ApiType;
  filters: Parameters<
    ApiType["customerAppointmentApi"]["appointmentPast"]
  >[0]["filters"];
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey: appointmentAsMemberQueryKeys.appointmentPast(filters),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      return (
        await api.customerAppointmentApi.appointmentPast({
          filters: {
            ...filters,
            nextPageToken: pageParam,
          },
        })
      ).data;
    },
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    initialPageParam: undefined,
    enabled,
  });
